import {Sequence} from 'components/Sequence';
import {CustomField, Strand} from 'constants/MolbioConstants';
import Annotation from 'molbio/annotations/backbone/Annotation';
import {modelEndToDisplay, modelStartToDisplay} from 'molbio/SeqUtil';

export interface AnnotationData {
  id: number;
  cid: string;
  name: string;
  annotation_type: string;
  color: string;
  notes: string;
  custom_fields: Array<CustomField>;
  editable: boolean;
  hover: boolean;
  selected: boolean;
  start: number;
  end: number;
  length: number;
  strand: Strand;
  visible: boolean;
  displayStart: number;
  displayEnd: number;
}

/**
 * Converter function for transforming annotation backbone models into the AnnotationData interface.
 *
 * The AnnotationData interface is used by newer React components.
 * @param annotation Backbone annotation data model to convert.
 * @param sequence Sequence model this annotation is part of.
 */
export function getAnnotationData(annotation: Annotation, sequence: Sequence): AnnotationData {
  return {
    id: annotation.get('_annotation').id,
    cid: annotation.cid,
    visible: annotation.visible(),
    name: annotation.name(),
    annotation_type: annotation.annotationType(),
    color: annotation.color(),
    notes: annotation.notes(),
    custom_fields: annotation.customFields(),
    hover: annotation.hover(),
    start: annotation.start(),
    end: annotation.end(),
    length: annotation.length(sequence),
    strand: annotation.strand(),
    editable: annotation.editable(),
    selected: annotation.selected(),
    displayStart: modelStartToDisplay(annotation.start(), sequence.startIndex()),
    displayEnd: modelEndToDisplay(annotation.end(), sequence.length(), sequence.startIndex()),
  };
}

export function getUniqueNonEmptyAnnotationTypes(annotations: Array<AnnotationData>): Array<string> {
  return [...new Set(annotations.map((data) => data.annotation_type).filter((type) => type))];
}
